// Mock data for Credjuris landing page

export const heroData = {
  headline: "Descubra exatamente por que seu crédito foi negado e saiba como resolver",
  subheadline: "Especialistas em perícia técnica de crédito. Analisamos SCR, Rating bancário e Score para identificar e corrigir os dados que estão impedindo sua aprovação.",
  ctaText: "Quero meu Diagnóstico de Crédito",
  ctaLink: "#diagnostico"
};

export const problemData = {
  title: "Nome limpo não garante crédito aprovado",
  description: "Muitos clientes chegam até nós frustrados: pagaram suas dívidas, estão com o nome limpo, mas continuam tendo crédito negado. O motivo? Os bancos analisam muito mais do que o Serasa.",
  points: [
    {
      title: "Rating Interno dos Bancos",
      description: "Cada banco possui um sistema próprio de classificação. Atrasos antigos, renegociações e comportamento de pagamento ficam registrados internamente por anos."
    },
    {
      title: "SCR do Banco Central",
      description: "O Sistema de Informações de Crédito registra todo seu histórico de operações de crédito. Anotações de prejuízo podem permanecer por até 10 anos."
    },
    {
      title: "Apontamentos de Prejuízo",
      description: "Dívidas baixadas como prejuízo pelos bancos continuam visíveis no sistema financeiro, mesmo após quitação, impedindo novas aprovações."
    }
  ],
  highlight: "Crédito não se pede. Crédito se constrói com dados corretos."
};

export const servicesPF = {
  title: "Pessoa Física",
  services: [
    {
      title: "Limpa Nome Judicial",
      description: "Atuação judicial para remoção de apontamentos indevidos em Serasa, SPC e Boa Vista, com base no Código de Defesa do Consumidor."
    },
    {
      title: "Liminar BACEN",
      description: "Ação judicial para correção ou exclusão de informações incorretas no SCR do Banco Central, restabelecendo seu histórico de crédito."
    },
    {
      title: "Estratégias de Aumento de Score",
      description: "Consultoria técnica para otimização do seu Score de crédito através de ações estratégicas e correção de inconsistências cadastrais."
    }
  ]
};

export const servicesPJ = {
  title: "Pessoa Jurídica",
  services: [
    {
      title: "Otimização de Rating (Concentre)",
      description: "Análise e correção do Rating empresarial junto ao sistema Concentre, utilizado pelos bancos para avaliar risco de crédito empresarial."
    },
    {
      title: "Kits de Documentação Financeira",
      description: "Estruturação completa da documentação financeira da empresa para apresentação a instituições financeiras e melhoria da análise de crédito."
    },
    {
      title: "Assessoria de Crédito Empresarial",
      description: "Acompanhamento especializado para empresas que buscam linhas de crédito, identificando e corrigindo os pontos que impedem a aprovação."
    }
  ]
};

export const diagnosticData = {
  title: "Comece pela Perícia Detalhada de Crédito",
  description: "Nossa análise técnica identifica exatamente o que está impedindo a aprovação do seu crédito. Você receberá um relatório completo com:",
  features: [
    "Análise completa do SCR (Banco Central)",
    "Verificação de Score em todas as bureaus",
    "Identificação de apontamentos internos",
    "Mapeamento de pendências ocultas",
    "Plano de ação personalizado"
  ],
  price: "A partir de R$ 147,00",
  priceNote: "Pessoa Física",
  ctaText: "Solicitar Análise Técnica"
};

export const faqData = [
  {
    question: "A Credjuris paga a dívida do cliente?",
    answer: "Não. A Credjuris não realiza quitação de dívidas. Nossa atuação é técnica e jurídica, focada na correção, remoção ou regularização de apontamentos indevidos através do Código de Defesa do Consumidor e perícia técnica especializada."
  },
  {
    question: "Existe garantia de aprovação de crédito?",
    answer: "Não prometemos aprovação de crédito. Nosso trabalho é identificar e corrigir dados incorretos que estão prejudicando sua análise de crédito. Com os dados regularizados, você terá melhores condições técnicas para aprovação, mas a decisão final é sempre da instituição financeira."
  },
  {
    question: "Qual o prazo médio do serviço?",
    answer: "O prazo varia conforme a complexidade do caso e o tipo de ação necessária. Processos administrativos podem ser resolvidos em 30 a 60 dias. Ações judiciais, dependendo da vara e complexidade, podem levar de 3 a 12 meses. Na perícia inicial, já informamos a estimativa específica para seu caso."
  },
  {
    question: "Por que meu crédito é negado mesmo com nome limpo?",
    answer: "Porque os bancos analisam muito mais do que Serasa e SPC. Eles consultam o SCR do Banco Central, seu Rating interno, histórico de relacionamento e outros dados que não aparecem nos bureaus tradicionais. Nossa perícia identifica exatamente onde está o problema."
  },
  {
    question: "Vocês atendem em todo o Brasil?",
    answer: "Sim. Nossa atuação é 100% digital e atendemos clientes em todo o território nacional. As ações judiciais são ajuizadas nos foros competentes, independente da sua localização."
  }
];

export const contactData = {
  whatsapp: "(65) 99601-7801",
  whatsappLink: "https://wa.me/5565996017801",
  email: "credjurismt@gmail.com",
  instagram: "@credjurismt",
  instagramLink: "https://instagram.com/credjurismt",
  disclaimer: "Somos uma consultoria de análise e regularização de dados. Não prometemos crédito fácil, prometemos dados limpos."
};
